import React from 'react';
import './Tools.css';

function Tools() {
  const tools = [
    {
      category: 'AI Platforms',
      items: ['ChatGPT', 'Claude', 'Codex', 'Grok', 'Nano', 'Banana']
    },
    {
      category: 'Development',
      items: ['LangGraph', 'LangChain', 'Cursor AI', 'ElevenLabs']
    },
    {
      category: 'Data & Analytics',
      items: ['Excel', 'Google Sheets', 'Zoho CRM', 'Salesforce']
    },
    {
      category: 'Communication',
      items: ['MS Teams', 'Slack', 'Email Platforms']
    }
  ];

  const capabilities = [
    {
      title: 'Deploy evaluations in seconds',
      description: 'Systematic frameworks for rapid AI output assessment'
    },
    {
      title: 'Wide range of AI models',
      description: 'Experience with ChatGPT, Claude, Codex, Grok, and more'
    },
    {
      title: 'Automatic pattern recognition',
      description: 'Identify recurring issues across large datasets instantly'
    },
    {
      title: '99%+ accuracy rate',
      description: 'Consistent evaluation criteria across thousands of items'
    }
  ];

  return (
    <section id="tools" className="tools">
      <h2 className="section-title">Tools & Capabilities</h2>
      
      <div className="capabilities-grid">
        {capabilities.map((cap, index) => (
          <div key={index} className="capability-card">
            <h3>{cap.title}</h3>
            <p>{cap.description}</p>
          </div>
        ))}
      </div>

      <div className="tools-section">
        <h3 className="tools-section-title">Technologies I Work With</h3>
        <div className="tools-grid">
          {tools.map((toolGroup, index) => (
            <div key={index} className="tool-group">
              <h4 className="tool-category">{toolGroup.category}</h4>
              <div className="tool-items">
                {toolGroup.items.map((item, itemIndex) => (
                  <span key={itemIndex} className="tool-item">{item}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Tools;

